import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Dataset, DatasetContent } from '@models';
import { Observable } from 'rxjs';
import { environment } from '@environment';

@Injectable({
  providedIn: 'root',
})
export class DatasetService {
  private http = inject(HttpClient);

  create(content: DatasetContent, seriesId?: string) {
    const endpoint = `${environment.kinkoHost}/dataset/`;
    return this.http.post<Dataset>(endpoint, {
      content: content,
      seriesId: seriesId
    }, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    });
  }

  publish(id: string, content: DatasetContent) {
    const endpoint = `${environment.kinkoHost}/dataset/${id}`;
    const params = new HttpParams().set('publish', 'true');

    return this.http.put<Dataset>(endpoint, content, {
      params: params,
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    });
  }

  get(id: string): Observable<Dataset> {
    const endpoint = `${environment.kinkoHost}/dataset/${id}`;

    return this.http.get<Dataset>(endpoint, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    });
  }

  update(id: string, content: DatasetContent) {
    const endpoint = `${environment.kinkoHost}/dataset/${id}`;

    return this.http.put<Dataset>(endpoint, content, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    });
  }

  delete(id: string) {
    const endpoint = `${environment.kinkoHost}/dataset/${id}`;

    return this.http.delete(endpoint, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    });
  }
}
